import React from "react";
import Logo from "../../../assets/img/logo_car.svg";

function logo() {
  return <img src={Logo} alt="RandomRideLogo" />;
}

export default logo;
